import { useRouter } from "@lib/hooks/useRouter";

const useIsTest = () => {
  const router = useRouter();
  return router.query.utm_source === "test";
};

export default useIsTest;
